import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Theme } from '@models/theme';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ThemeService } from '@services/theme.service';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[vnmTheme]'
})
export class ThemeDirective implements OnInit, OnChanges {
  @Input('vnmTheme') theme: Theme;

  constructor(
    private elementRef: ElementRef,
    private themeService: ThemeService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.theme) {
      this.applyTheme(this.theme);
    }
  }

  get element(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.applyTheme(this.theme);

    this.themeService.change
      .pipe(
        untilDestroyed(this),
        filter((theme) => theme === this.theme)
      )
      .subscribe((theme: Theme) => this.applyTheme(theme));
  }

  applyTheme(theme: Theme) {
    for (const key in theme.properties) {
      // keep this so we don't override specific component theming
      this.element.style.setProperty(`--${key}`, theme.properties[key]);

      // apply the theme to the document, so it applies to all dialogs/sidebars etc
      this.document.documentElement.style.setProperty(`--${key}`, theme.properties[key]);
    }
  }
}
